"use client";

import { cn } from "@/lib/utils/cn";

type RuleDrawProps = {
  className?: string;
  timeline?: "load" | "view";
  tone?: "line" | "accent";
  delayMs?: number;
};

export function RuleDraw({
  className,
  timeline = "view",
  tone = "accent",
  delayMs,
}: RuleDrawProps) {
  return (
    <div
      aria-hidden="true"
      className={cn(
        "h-px w-full",
        timeline === "load" ? "lift-line" : "rule-draw",
        tone === "line" ? "bg-line" : "bg-line",
        className,
      )}
      style={delayMs ? { animationDelay: `${delayMs}ms` } : undefined}
    />
  );
}
